module.exports = __webpack_public_path__ + "static/media/home-slide-4.70d7c5b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MainImage/home-slide-4.jpg
// module id = 339
// module chunks = 0